import { pressDuration } from '@braindate/ui/lib/token/animation';

export default {
  root: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    transformOrigin: 'center center',
    transition: `transform ${pressDuration}`,
    color: ({ theme, isReverseColor }: Record<string, any>) =>
      isReverseColor ? theme.textColorReverse : theme.accentColor,
    '&:hover': {
      transform: 'scale(1.15, 1.15)',
    },
    '&:active': {
      transform: 'scale(0.85, 0.85)',
    },
  },
};
